import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Formik, Field } from 'formik';
import { object, string, number } from 'yup';
import {  Col } from 'react-bootstrap';
import {
  TextField
} from 'formik-material-ui';
import {
  userOptionsPromise
} from './establishment-filter.form';
import {
  MaterialSelectFormik
} from '../components/select-field.component';

const PHONE_NUMBER_REGEX = new RegExp('^[\\d\\s\\+\\(\\)\\.\\-]+$');
const validationSchema = object().shape({
  name: string().when('user_id', {
    is: false,
    then: string().required()
  }),
  phone: string().when('user_id', {
    is: false,
    then: string().matches(PHONE_NUMBER_REGEX).required()
  }),
  phone_area_code: string().when('user_id', {
    is: false,
    then: string().matches(PHONE_NUMBER_REGEX).required()
  }),
  email: string().when('user_id', {
    is: false,
    then: string().email().required()
  }),
  user_id: number()
});

const handleSubmitting = (fn) => (values, actions) => {
  return fn(values)
    .then(() => actions.setSubmitting(false))
    .catch(() => actions.setSubmitting(false));
};

export const UserForm = ({
  onSubmit,
  name,
  email,
  phone,
  phone_area_code,
  phone_alt,
  user_id,
  getForm
}) => {
  //console.log('USER FORM');
  return (
  <Col>
    <Formik ref={node => getForm && getForm(node)}
      initialValues={{
        name: name || '',
        phone: phone || '',
        phone_area_code: phone_area_code || '',
        phone_alt: phone_alt || '',
        email: email || '',
        user_id: user_id || ''
      }}
      enableReinitialize
      onSubmit={handleSubmitting(onSubmit)}
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={true}
      render={({
        values,
        errors,
        status,
        touched,
        isSubmitting,
        handleSubmit,
        setFieldValue,
        setFieldTouched
      }) => (
        <Grid item md={12}>
        <form onSubmit={handleSubmit}>
          <Grid item md={12}>
            <Field
              name="name"
              label="Nome"
              type="text"
              component={TextField}
              variant="outlined"
              margin="normal"
              fullWidth
              disabled={true}
            />
            <Field
              name="email"
              label="Email"
              type="email"
              variant="outlined"
              margin="normal"
              component={TextField}
              fullWidth
              disabled={true}
            />
            <Field
              name="phone_area_code"
              label="Indicativo"
              type="number"
              variant="outlined"
              margin="normal"
              component={TextField}
              disabled={true}
            />
            <Field
              name="phone"
              label="Telefone"
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              fullWidth
              disabled={true}
            />
            <Field
              name="phone_alt"
              label="Telefone alternativo"
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              fullWidth
              disabled={true}
            />
          </Grid>
          <MaterialSelectFormik
            name="user_id"
            placeholder="user_id"
            label="Utilizador"
            search
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            value={''+values.user_id}
            optionsFetcher={userOptionsPromise}
          />
        </form>
        </Grid>
      )}/>
  </Col>
  );
}
